import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=79820e70&"
import script from "./FileUpload.vue?vue&type=script&lang=js&"
export * from "./FileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dev.pixflow.app/httpdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('79820e70', component.options)
    } else {
      api.reload('79820e70', component.options)
    }
    module.hot.accept("./FileUpload.vue?vue&type=template&id=79820e70&", function () {
      api.rerender('79820e70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/FileUpload.vue"
export default component.exports